"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Monitor, Presentation, GraduationCap } from "lucide-react";
export default function OurSolutions() {
  const {
    ref: solutionRef1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: solutionRef2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: solutionRef3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const solutions = [{
    ref: solutionRef1,
    isVisible: isVisible1,
    icon: Monitor,
    title: "LED Wall Display Solutions",
    description: "Transform any space with stunning, high-resolution LED wall displays. Our solutions deliver vibrant colors, seamless integration, and cutting-edge technology for immersive visual experiences in corporate, retail, and entertainment environments."
  }, {
    ref: solutionRef2,
    isVisible: isVisible2,
    icon: Presentation,
    title: "Digital Signage",
    description: "Engage your audience with dynamic digital signage solutions. From interactive displays to content management systems, we provide end-to-end digital signage that captures attention and communicates your message effectively."
  }, {
    ref: solutionRef3,
    isVisible: isVisible3,
    icon: GraduationCap,
    title: "Interactive Touch Screen",
    description: "Revolutionize learning with interactive touch screen technology. Our education solutions empower teachers and students with collaborative tools, intuitive interfaces, and enhanced engagement for modern classrooms."
  }];
  return <section id="our-solutions" className="w-full bg-light-background py-16 px-4 md:py-24 md:px-8">
      <div className="mx-auto max-w-7xl">
        <h2 className="text-center text-3xl font-bold text-foreground md:text-4xl mb-12 md:mb-16">
          Our Solutions
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {solutions.map((solution, i) => {
          const IconComponent = solution.icon;
          return <div key={i} data-index={i} ref={solution.ref} className="group bg-secondary/10 rounded-[4px] p-8 transition-all duration-[120ms] ease-out hover:-translate-y-[2px] hover:shadow-[0_4px_16px_rgba(0,0,0,0.12),0_2px_6px_rgba(0,0,0,0.08)]" style={{
            opacity: solution.isVisible ? 1 : 0,
            transform: solution.isVisible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 200ms ease-out, transform 200ms ease-out",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04), 0 1px 3px rgba(0,0,0,0.08)"
          }}>
                <div className="flex flex-col items-start">
                  <div className="mb-6 p-3 bg-primary/10 rounded-[4px] transition-all duration-[120ms] group-hover:bg-primary/20">
                    <IconComponent className="w-8 h-8 text-primary" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-xl font-semibold text-foreground mb-4 md:text-2xl">
                    {solution.title}
                  </h3>
                  <p className="text-base text-foreground leading-relaxed">
                    {solution.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}